import { LmgService } from "../resource";

const Customer = {
  namespaced: true,
  state: {
    datas: [],
    data: {},
  },
  mutations: {
    SET_DATAS(state, payload) {
      state.datas = payload;
    },
    SET_DATA(state, payload) {
      state.data = payload;
    },
  },
  actions: {
    createData({ commit, state }, payload) {
      return LmgService.CustomerCreate(payload);
    },
	updateData({ commit, state }, payload) {
		return LmgService.CustomerUpdate(payload.id , payload.payload) ;
	},
  
    async listData({ commit, state },payload) {
      try {
        const data = await LmgService.CustomerList(payload);
        if (data.data.Data == null) {
          commit("SET_DATAS", []);
        } else {
          commit("SET_DATAS", data.data.Data);
        }
      } catch (err) {
        commit("SET_DATAS", []);
      }
    },
    checkID({ commit, state },payload) {
	    return  LmgService.CustomerCheckID(payload);
    }
  },
  getters: {
    getDatas(state) {
      return state.datas;
    },
    getData(state) {
      return state.data;
    },
    
  }
};

export default Customer;
